import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { doGetSession } from '../utilities';

function Index() {
    const router = useRouter()
    const [session, setSession] = React.useState(null)

    React.useEffect(() => {
        let mtd = true
        if (mtd) {
            doGetSession().then((sess) => {
                // console.log('session',session)
                setSession(sess)
                if (sess && sess.isLoggedIn) {
                    if (sess.user.type.toLowerCase() === 'admin' || sess.user.type.toLowerCase()?.trim()?.split(' ')?.join('_') == 'scope_manager') {
                        if (typeof window !== 'undefined') {
                            window.location.href = '/admin/'
                        } else if (router) {
                            router.push('/admin/', undefined, { unstable_skipClientCache: true })
                        }
                    }
                    else if (sess.user.type.toLowerCase().includes('coordinator')) {
                        if (typeof window !== 'undefined') {
                            window.location.href = '/region/'
                        } else if (router) {
                            router.push('/region/', undefined, { unstable_skipClientCache: true })
                        }
                    }
                    else if (sess.user.type.toLowerCase() === 'partner') {
                        if (typeof window !== 'undefined') {
                            window.location.href = '/partner/'
                        } else if (router) {
                            router.push('/partner/', undefined, { unstable_skipClientCache: true })
                        }
                    }
                    else if (sess.user.type.toLowerCase() === 'user' || sess.user.type.toLowerCase()?.trim()?.split(' ')?.join('_') == 'lab_manager' || sess.user.type.toLowerCase()?.trim()?.split(' ')?.join('_') == 'participant') {
                        if (typeof window !== 'undefined') {
                            window.location.href = '/user/'
                        } else if (router) {
                            router.push('/user/', undefined, { unstable_skipClientCache: true })
                        }
                    }
                } else {
                    console.log('No Session found.')
                    if (typeof window !== 'undefined') {
                        window.location.href = '/auth/login'
                    } else if (router) {
                        router.push('/auth/login', undefined, { unstable_skipClientCache: true })
                    }
                }
            })
        }
        return () => {
            mtd = false
        }
    }, [])

    return (<>

        <Head>
            <title>EPT | Loading...</title>
            <meta name="description" content="EPT" />
            <link rel="icon" href="/images/favicon.ico" />
        </Head>
        <main style={{ width: '100%', height: '85vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className='d-flex flex-column gap-2 align-items-center justify-content-center'>
                <h5 className='mb-0 text-muted' style={{ marginLeft: '20px' }}>Loading...</h5>
                <div className="spinner-border spinner-border-xl" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </main>
    </>
    )
}

export default Index